// removed by extract-text-webpack-plugin
module.exports = {"wrap":"src-components-wrappers-ParallaxWrapper-style----general-module---wrap---1nyY7 breakPointM-height-100 breakPointM-width-100"};


//////////////////
// WEBPACK FOOTER
// ./src/components/wrappers/ParallaxWrapper/style/general.module.css
// module id = 1497
// module chunks = 168707334958949